// Copyright (C) 2019 TANNER AG

import React from "react";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core";
import { Paper } from "./paper";
import Compare from "./compare";
import CountUp from "react-countup";
import { withStore } from "../store/withstore";

const styles = {
	container: {
		position: "relative",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		height: "100%",
		width: "100%"
	},
	paper: {
		flexBasis: 0,
		flexGrow: 1,
		width: "100%",
		height: "100%",
		maxWidth: "100%"
	},
	pin: {
		position: "absolute",
		width: 150,
		height: 150,
		backgroundColor: "#fff",
		borderRadius: "50%",
		border: "6px solid #90bb00",
		boxShadow: "0 0 10px 0 rgba(48,60,73,0.1)",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		color: "#90bb00",
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: "bold",
		fontStretch: "condensed",
		fontSize: "45px",
		lineHeight: "100px"
	}
};

const Result = withStyles(styles)((props) => {
	const { classes, store: { a, b, configuration }, history } = props;

	if (!a.bus.id || !b.bus.id || !configuration) {
		history.push("/tco-lcc");
		return null;
	}

	return (
		<div className={classes.container}>
			<Compare>
				{({ percentageDifference, bus }) => (
					<React.Fragment>
						<Paper
							data={a}
							success={bus === "A"}
							percent={percentageDifference}
							configuration={configuration}
							variant={a.bus.id === b.bus.id}
						/>
						<Paper
							data={b}
							success={bus === "B"}
							percent={percentageDifference}
							configuration={configuration}
							variant={a.bus.id === b.bus.id}
						/>
						<span className={classes.pin}>
							<CountUp
								prefix="–"
								suffix="%"
								end={percentageDifference}
							/>
						</span>
					</React.Fragment>
				)}
			</Compare>
		</div>
	);
});

export default compose(
	withStore,
	withStyles(styles)
)(Result);



// WEBPACK FOOTER //
// ./src/tco/result/index.js